import { render, staticRenderFns } from "./VoiceItem2.vue?vue&type=template&id=8b505452&scoped=true"
import script from "./VoiceItem2.vue?vue&type=script&lang=js"
export * from "./VoiceItem2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b505452",
  null
  
)

export default component.exports